<script setup lang="ts">
import { mdiImageOffOutline } from "@mdi/js";
import { SoftCard, SoftRadialProgress } from "@soft-db/ui";

const { src, icon = mdiImageOffOutline } = defineProps<{
	src?: string;
	icon?: string;
}>();

const error = ref(false);

const mappedSrc = computed(() => {
	if (!src) return "";

	if (!src.includes("http")) {
		return `http://${src}`;
	}

	return src;
});
</script>

<template>
	<SoftCard class="flex items-center justify-center rounded-md border-0">
		<SoftImg
			v-if="!error && src"
			:src="mappedSrc"
			class="h-full w-full rounded-md"
			@error="error = true"
		>
			<template #placeholder>
				<SoftRadialProgress class="h-full w-full" color="primary" />
			</template>
		</SoftImg>
		<SoftIcon v-else class="size-24 text-gray-400">
			{{ icon }}
		</SoftIcon>
	</SoftCard>
</template>
